import { render, staticRenderFns } from "./FormulateMarkdown.vue?vue&type=template&id=6ec8f0e6&scoped=true&"
import script from "./FormulateMarkdown.vue?vue&type=script&lang=ts&"
export * from "./FormulateMarkdown.vue?vue&type=script&lang=ts&"
import style0 from "./FormulateMarkdown.vue?vue&type=style&index=0&id=6ec8f0e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec8f0e6",
  null
  
)

export default component.exports